import { faBook, faFile, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useRef, useState } from 'react'
import { useLang } from '../../../../../../../language'
import { Button, Table } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { EstadosEventoServices, EstadosVisadoServices } from '../../../../../../../services/statics.service'
import { useForm } from '../../../../../../../hooks/useForm'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { cloneDeep } from 'lodash'
import { isStatusSucess } from '../../../../../../../helpers/helpers'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { ModalDocumento } from './ModalDocumento'
import { LoaderFormProducto } from '../LoaderFormProducto'
import { DocumentosServices } from '../controllers/services/documentos.service'
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../../store'

export const Documentos = ({ formData = {}, idaparato, fetchSuccess }: any) => {

    const Lang = useLang()

    const [formDatosGenerales, handleInputDatosGenerales, handleFormDatosGenerales, resetDatosGenerales] = useForm({
        // ...InformacionAdicionalAdapters.GET.receive.schema({}),
    })

    const [valuesValidationEvento, handleValidationEvento, handleResetValidationEvento] = useValidator({
        descripcion: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    const [fetchDocumentosGET, fetchDocumentosGETData] = DocumentosServices.GET(idaparato)

    useEffect(() => {

        fetchDocumentosGET()

    }, [])

    useEffect(() => {

        if (isStatusSucess(fetchDocumentosGETData.status)) {

            handleFormDatosGenerales({
                ...fetchDocumentosGETData.data
            })
        }
    }, [fetchDocumentosGETData])

    const navigate = useNavigate()

    const handleChangeChecks = (e: any, name: any) => {

        let listChecksTemp = cloneDeep(formDatosGenerales[name])

        if (e.target.checked) {

            listChecksTemp.push(e.target.name)

        } else {

            listChecksTemp = listChecksTemp.filter((item: any) => item !== e.target.name)
        }

        handleFormDatosGenerales({
            ...formDatosGenerales,
            [name]: listChecksTemp
        })
    }
    const staticEstadosEventoServices: any = EstadosEventoServices.GET()


    // // --------------- PATCH Evento

    // const [fetchInscripcionPATCH, fetchInscripcionPATCHData] = InformacionAdicionalServices.PATCH()

    // const handleSubmitEditar = () => {

    //     if (handleValidationEvento(formDatosGenerales)) {
    //         fetchInscripcionPATCH({
    //             id: formDatosGenerales.id,
    //             body: {
    //                 ...formDatosGenerales,
    //             }
    //         })
    //     }

    //     // resetDatosGenerales()
    // }

    // useEffect(() => {

    //     if (isStatusSucess(fetchInscripcionPATCHData.status)) {

    //         resetDatosGenerales()

    //         fetchDocumentosGET()
    //     }
    // }, [fetchInscripcionPATCHData])


    const handleEditorChange = (name: string, content: any) => {

        const target = {
            name,
            value: content,
        }

        handleInputDatosGenerales({ target })
    }

    // Crear nueva colegiatura

    const [showModal_Documento, setShowModal_Documento] = useState({
        value: false,
        payload: {}
    });

    const handleCloseModal_Documento = () => setShowModal_Documento({
        value: false,
        payload: {}
    });

    const handleShowModal_Documento = (payload: object) => setShowModal_Documento({
        value: true,
        payload
    });


    const [fetchDocumentoData, setFetchDocumentoData] = useState<any>({ data: null, loading: null, error: null, status: null });

    const isMounted = useRef(true)

    useEffect(() => {
        return () => {
            isMounted.current = false;
        }
    }, [])

    const { auth } = useSelector((state: RootState) => state.auth)

    const handleFetchFile = (url: any) => {

        setFetchDocumentoData({ data: null, loading: true, error: null, status: null })

        const config: any = {
            responseType: 'blob',
            headers: { Authorization: `Bearer ${auth.token}` }
        };

        axios.get(url, config).then((response: any) => {
            setFetchDocumentoData({
                loading: false,
                error: null,
                data: response,
                status: response,
            });
            setactiveFile('-')

        });
    }

    useEffect(() => {
        if (fetchDocumentoData.data) {

            // 2. Create blob link to download
            const docData = fetchDocumentoData.data

            const filename = docData?.headers?.['content-disposition']?.split('filename=')?.[1]
            const blobData = docData?.data

            const instanceBlob = new Blob([blobData])

            const date = new Date()

            const url = window.URL.createObjectURL(instanceBlob);
            const link: any = document.createElement('a');

            link.href = url;
            link.setAttribute('download', `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}_${filename}`);
            // 3. Append to html page
            document.body.appendChild(link);

            // 4. Force download
            link.click();

            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);

            setFetchDocumentoData({ data: null, loading: true, error: null, status: null })

        }
    }, [fetchDocumentoData])

    const [activeFile, setactiveFile] = useState('-')

    const handleSubmitDescargar = (item: any) => {
        handleFetchFile(item.url_adjunto)
        setactiveFile(item.url_adjunto)
    }

    return (
        <div>
            <div className='d-flex align-items-center justify-content-between mt-3'>
                <h5 className='mb-0'>{Lang('DOCUMENTOS')}</h5>
                <div className='d-flex justify-content-end'>
                    <Button variant='primary' size='sm' onClick={() => handleShowModal_Documento({
                        action: 'CREATE',
                        idaparato
                    })}>
                        <FontAwesomeIcon icon={faPlus} className='me-1' /> {Lang('NUEVO_DOCUMENTO')}
                    </Button>
                </div>
            </div>

            {
                fetchDocumentosGETData.loading ?
                    <div className='mt-3 '>
                        <LoaderFormProducto />
                    </div>
                    :
                    <div className="row mt-3 mb-3">

                        <div className="col-12">

                            <Table bordered responsive>
                                <thead>
                                    <tr>
                                        <th>{Lang('TITULO')}</th>
                                        <th className='text-center'></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        fetchDocumentosGETData.data?.items?.map((item: any) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        {item.nombre}
                                                    </td>
                                                    <td className='text-center text-nowrap' valign='middle'>
                                                        <ButtonSpinner
                                                            variant="outline-primary" type="submit" size='sm'
                                                            handleSubmit={() => handleSubmitDescargar(item)} fetchDataLoading={[activeFile === item.url_adjunto && fetchDocumentoData.loading]}
                                                            icon={<FontAwesomeIcon icon={faFile} />}
                                                        />
                                                        <Button onClick={() => handleShowModal_Documento({
                                                            action: 'EDIT',
                                                            id: item.id,
                                                            form: item,
                                                        })} size='sm' className='text-nowrap ms-3' >
                                                            <FontAwesomeIcon icon={faBook} />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    {
                                        fetchDocumentosGETData.data?.items?.length === 0 &&
                                        <tr>
                                            <td colSpan={20} className='text-center py-5'>{Lang('PARRAFO_NO_HAY_DATOS_PARA_MOSTRAR')}</td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>

                        </div>

                    </div>

            }

            {/* <ModalStatusServer fetchData={fetchInscripcionPATCHData} /> */}

            <ModalDocumento
                showModal_Documento={showModal_Documento}
                handleCloseModal_Documento={handleCloseModal_Documento}
                fetchDocumentosGET={fetchDocumentosGET}
            />

        </div>
    )
}
